import styled from "styled-components";
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 22px;
  border-bottom: 1px solid #d1d0cb;
  padding: 28px 0 7px;
  margin: 0 30px;
  background-color: #fafcff;
`;

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding-left: 10px;
    min-height: 30px;
    width: 233px;
  }
  img {
    position: absolute;
    right: 8px;
  }
`;

const ActionWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 10px 0;
  background: var(--filter-bar-bg);
  padding: 12px 28px;
  margin: 0;
  > div {
    border-right: 1px solid #cdcfd0;
    padding: 0 15px;
    :first-child {
      padding-left: 0;
    }
  }
`;
const DateRangePickerWrapper = styled.div`
  align-items: center;
  gap: 10px;
  padding: 0 10px;

  display: flex;
  .label {
    font-size: 13px;
    line-height: 150.5%;
    color: #fff;
  }
  .MuiInputBase-root {
    max-width: 150px;
    background: #ffffff;
    border-radius: 6px;
  }
  .MuiInputBase-input {
    font-size: 13px;
    line-height: 150%;
    padding: 6px 10px;
  }
`;
const ActionBtn = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  svg {
    cursor: pointer;
  }
`;

const RefreshBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--theme-text);
  border: 1px solid var(--filter-bar-btn-border);
  border-radius: 30px;
  background-color: transparent;
  min-height: 30px;
  margin-left: 10px;
  :disabled {
    opacity: 0.5;
    cursor: context-menu;
  }
`;

const TableWrapper = styled.div`
  &.no-pagination {
    .MuiDataGrid-footerContainer {
      display: none !important;
    }
  }
  > div {
    height: calc(100vh - 188px);
  }
  .MuiDataGrid-root {
    border: none;
  }
  .MuiDataGrid-virtualScroller {
    margin-top: 40px !important;
  }
  .MuiDataGrid-cell {
    justify-content: center !important;
    border: none !important;
    font-size: 12px;
    line-height: 150.5%;
    /* min-height: 30px !important; */
    font-weight: 500;
  }
  .MuiDataGrid-row {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
    min-height: 30px !important;
    margin: 2.5px;
    background: var(--inner-section-bg);
    :nth-child(even) {
      background: #f4f4d4;
    }
  }
  .MuiDataGrid-columnHeader {
    line-height: 40px !important;
    height: 40px !important;
  }
  .MuiDataGrid-columnHeaders {
    border: none;
    min-height: 40px !important;
    .MuiDataGrid-columnHeaderTitle {
      font-size: 12px;
    }
  }
`;
const TableMainWrapper = styled.div`
  padding: 0 25px;
  background: #fcfcfc;
`;

export {
  Container,
  SearchWrapper,
  ActionWrapper,
  ActionBtn,
  RefreshBtn,
  TableWrapper,
  TableMainWrapper,
  DateRangePickerWrapper,
};
